import { useEffect, useState } from 'react'

/** Le pas de l'horloge des écrans : ce qu'ils en lisent ne descend jamais sous la minute. */
const TICK = 60_000

/**
 * L'heure à laquelle l'écran se lit, relue chaque minute.
 *
 * Sans elle, ce qui dépend de l'heure se fige au montage : rien ne re-rend un écran tant qu'aucune
 * écriture Dexie n'a lieu. « À l'instant » resterait affiché une heure après l'envoi
 * (« Notifications »), et un rendez-vous fini garderait sa couleur dans l'agenda (#577).
 */
export function useNow(): Date {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const tick = setInterval(() => setNow(new Date()), TICK)
    return () => clearInterval(tick)
  }, [])

  return now
}
